import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

import medifriendRxIcon from 'assets/icons/medifriend-rx.svg';
import kioskImage from 'assets/images/kiosk.svg';

import './reset-password-view.scss';


const ResetPasswordView = ({
  resetPasswordRouteStore,
  resetPassword
}) => (
  <div className='c-ChangePasswordView'>
    <div className='primary-panel'>
      <div className='sub-panel left-panel'>
        <img
          className='logo-icon'
          src={medifriendRxIcon}
        />
        <img
          className='kiosk-image'
          src={kioskImage}
        />
      </div>
      <form className='sub-panel right-panel' onSubmit={resetPassword}>
        <div className='back-to-sign-in'>
          <Link to='/login' onClick={() => resetPasswordRouteStore.setInitialState()}>
            Back to sign in
          </Link>
        </div>
        <div className='greeting-text'>
          <h3>Reset password</h3>
        </div>
        <div className='input-fields'>
          <div className='input-field'>
            <div className='input-label'>
              Email
            </div>
            <div>
              <input value={resetPasswordRouteStore.email} onChange={evt => resetPasswordRouteStore.setValue('email', evt.target.value)} autoComplete="off" />
            </div>
          </div>
        </div>
        <div className='panel-footer'>
          <input
            className='sign-up-button'
            type='submit'
            value='Reset password'
          />
          {
            !!resetPasswordRouteStore.errorMessage &&
            <div className='error-message'>
              {
                resetPasswordRouteStore.errorMessage
              }
            </div>
          }
          {
            resetPasswordRouteStore.isSuccess &&
            <div className='success'>
              Email sent, please check your mail.
            </div>
          }
        </div>
      </form>
    </div>
  </div>
);

export default observer(ResetPasswordView);
